define(["exports", "../LinterRule", "../l10n"], function (_exports, _LinterRule, _l10n) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.rule = void 0;
  _LinterRule = _interopRequireDefault(_LinterRule);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  const name = "no-http-props";
  const meta = {
    en: {
      description: "Insecure URLs are not allowed in `respecConfig`.",
      howToFix: "Please change the following properties to 'https://': "
    }
  }; // Fall back to english, if language is missing

  const lang = _l10n.lang in meta ? _l10n.lang : "en";
  /**
   * Runs linter rule.
   *
   * @param {Object} conf The ReSpec config.
   * @param {Document} doc The document to be checked.
   */

  function lintingFunction(conf, doc) {
    // We can only really perform this check over http/https
    if (!doc.location.href.startsWith("http")) {
      return;
    }

    const offendingMembers = Object.getOwnPropertyNames(conf) // this check is cheap, "prevED" is w3c exception.
    .filter(key => key.endsWith("URI") || key === "prevED") // this check is expensive, so separate step
    .filter(key => new URL(conf[key], doc.location.href).href.startsWith("http://"));

    if (!offendingMembers.length) {
      return;
    }
    /** @type {import("../../core/LinterRule").LinterResult} */


    const result = _objectSpread({
      name,
      occurrences: offendingMembers.length
    }, meta[lang]);

    result.howToFix += "".concat(offendingMembers.map(item => "`".concat(item, "`")).join(", "), ".");
    return result;
  }

  const rule = new _LinterRule.default(name, lintingFunction);
  _exports.rule = rule;
});
//# sourceMappingURL=no-http-props.js.map